import GoogleMapReact from 'google-map-react';
import {FC, useEffect, useRef, useState} from "react";
import marker from '../../assets/markers/marker-selected-md.png'
import { nightMode } from "./googleStyles";
import {useTheme} from "@material-ui/core";
import finishIcon from "../../assets/end.png";
import startIcon from "../../assets/start.png";
import { endpoints } from '../../constants'

type Props = {
    location: {
        lat: number,
        lng: number
    },
    margin: number,
    setCurrentLocation: React.Dispatch<React.SetStateAction<string>>,
    trip?: null | Array<{lat:number, lng:number}>
}

const MapWrapper: FC<Props> = ({ location , margin, setCurrentLocation, trip}) => {
    const [mapDrawings, setMapDrawings] = useState<any>([])

    const theme = useTheme()
    const mapRef = useRef<any>(null);
    const mapsRef = useRef<any>(null)

    const mapOptions = {
        styles: theme.palette.type === 'dark' ? nightMode : null,
        zoomControl: true,
        mapTypeControl: true,
        scaleControl: true,
        streetViewControl: true,
        rotateControl: true,
        fullscreenControl: false,
    }


    useEffect(() => {
        if(!mapsRef.current) return
        const map = mapRef.current
        const maps = mapsRef.current

        if(mapDrawings.length > 0) {
            mapDrawings.forEach((drawing: any) => drawing.setMap(null))
        }

        const mapDrawingsArray = [];

        if(!trip) {
            const tracefyMarker: any = new maps.Marker({
                position: location,
                map,
                icon: marker
            });

            const marginCircle = new maps.Circle({
                strokeColor: "#173c60",
                strokeOpacity: 0.8,
                strokeWeight: 1.5,
                fillColor: "#173c60",
                fillOpacity: 0.35,
                map,
                center: location,
                radius: margin
            });

            mapDrawingsArray.push(tracefyMarker, marginCircle)
        }

        if(trip) {
            const tripStart = trip[0]

            const tripLine = new maps.Polyline({
                path: trip,
                geodesic: true,
                strokeColor: '#c97200',
                strokeOpacity: 0,
                icons: [{ icon: {path: 'M 0, 0 0, 0.1', strokeOpacity: 1, scale: 5}, offset: '0', repeat: '10px'}],
                strokeWeight: 4,
            });
            tripLine.setMap(map)

            const bounds = new google.maps.LatLngBounds();
            trip.forEach((point: any) => bounds.extend(point))
            map.fitBounds(bounds);

            // Tracefy finish marker
            const finishMarker = new maps.Marker({
                position: location,
                map,
                icon: finishIcon
            });

            // Tracefy start marker
            const startMarker = new maps.Marker({
                position: tripStart,
                map,
                icon: startIcon
            });

            mapDrawingsArray.push(tripLine, finishMarker, startMarker)
        }

        setMapDrawings([...mapDrawingsArray])


        try {
            fetch(`${endpoints.backendEndpoint}/investigations/geocode-address`,
                {
                    method: 'POST',
                    body: JSON.stringify({latitude: location.lat, longitude: location.lng}),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                .then((res) => res.json())
                .then(data => {
                    setCurrentLocation(data.data.address)
                }).catch((e) => {
                console.log(e)
                setCurrentLocation('no address found...')
            })

            fetch(`https://views-api.deno.dev/?key=tracefy_missing`, { cache: 'no-store' }).then(res => res.json())
        } catch (e) {
            console.log(e)
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location, trip, margin])


    return (
        <div className={theme.palette.type === 'dark' ? 'tracefy__google-map--nightmode' : ''} style={{height: '100%', width: '100%'}}>
            <GoogleMapReact
                bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAPS_KEY }}
                defaultCenter={{lat: 52.0044681, lng: 4.3597472}}
                center={location}
                yesIWantToUseGoogleMapApiInternals
                defaultZoom={14}
                options={mapOptions}
                // @ts-ignore
                onGoogleApiLoaded={({ map, maps }) => {
                    mapRef.current = map
                    mapsRef.current = maps
                }}
            >
            </GoogleMapReact>
        </div>
    );
}

export default MapWrapper
